<template>
  <sui-modal v-model="open" :closable="false">
    <sui-modal-header>{{$t('weUserCookies')}}</sui-modal-header>
    <sui-modal-content>
      <p>{{$t('cookieText')}}</p>
      <sui-form>
        <sui-form-fields equal-width style="margin: 1em 3em">
          <sui-form-field>
            <sui-checkbox :label="$t('essentiell')" toggle disabled v-model="current.essentiell" />
          </sui-form-field>
          <sui-form-field>
            <sui-checkbox :label="$t('statistics')" toggle v-model="current.statistics" />
          </sui-form-field>
          <!--
          <sui-form-field>
            <sui-checkbox label="Marketing" toggle v-model="current.marketing" />
          </sui-form-field>
          <sui-form-field>
            <sui-checkbox label="Externe Medien" toggle v-model="current.externalMedia" />
          </sui-form-field>
          -->
        </sui-form-fields>

        <sui-form-field>
          <sui-button fluid color="blue" @click="saveAll" :content="$t('acceptAll')" />
        </sui-form-field>
        <sui-form-field>
          <sui-button fluid color="grey" @click="save" :content="$t('save')" basic style="opacity:0.5" />
        </sui-form-field>
      </sui-form>
    </sui-modal-content>
    <sui-modal-actions>
      <sui-segment vertical aligned="center" style="padding: 0">
        <!--<a class="miniMenu" @click="toggleDetails()">Cookie-Details</a> &nbsp;-&nbsp;-->
        <a class="miniMenu" href="/imprint" @click="select($event, '/imprint')">{{ $t('labelImprint') }}</a> &nbsp;-&nbsp;
        <a class="miniMenu" href="/privacy" @click="select($event, '/privacy')">{{ $t('labelPrivacy') }}</a> &nbsp;-&nbsp;
        <LanguageChooser />
      </sui-segment>
    </sui-modal-actions>
  </sui-modal>
</template>

<script>
  import LanguageChooser from './LanguageChooser.vue'
  import StorageService from '@/services/StorageService.js'

  export default {
    name: 'CookieLaw',
    components: {
      LanguageChooser,
      StorageService
    },
    data() {
      return {
        open: false,
        accepted: false,
        current: {
          essentiell: true,
          statistics: false,
          marketing: false,
          externalMedia: false,
        },
        details: false,
      };
    },
    async created() {
      let accepted = await StorageService.isCookieAccepted()
      let cookies = await StorageService.getCookieContent()

      if (accepted == false) {
        this.accepted = false
        this.open = true
      } else {
        this.open = false
        this.accepted = true
      }
      if (cookies != false) {
        this.current = cookies
      }
    },
    methods: {
      toggle() {
        this.open = !this.open;
      },
      toggleDetails() {
        this.details = !this.details;
      },
      saveAll() {
        this.current.essentiell = true
        this.current.statistics = true
        //this.current.marketing = true
        //this.current.externalMedia = true
        this.save()
      },
      save() {
        StorageService.setCookieAccepted(true)
        StorageService.setCookieContent(this.current)
        this.accepted = true
        this.open = false
      },
      select(event, target) {
        if (event) {
          event.preventDefault()
        }
        this.$router.push(target)
        this.open = false
      },
    },
    watch: {
      '$route.path': function () {
        if (this.accepted == false) {
          let a = this.$route.path
          if (a != '/imprint' && a != '/privacy') {
            this.open = true
          }
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  a.miniMenu {
    color: #808080 !important;
    cursor: pointer;
  }

    a.miniMenu:hover {
      color: #707070 !important;
    }
</style>
